module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "navbar navbar-toggleable-md navbar-light bg-faded"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "collapse navbar-collapse",
    attrs: {
      "id": "navbarNav"
    }
  }, [_c('div', {
    staticClass: "navbar-nav ml-auto"
  }, [_c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasPermission(12)),
      expression: "hasPermission(12)"
    }],
    staticClass: "nav-item dropdown"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu",
    attrs: {
      "aria-labelledby": "navbarDropdownMenuLink"
    }
  }, [_c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$canAccess(12, 31)),
      expression: "$canAccess(12, 31)"
    }],
    staticClass: "nav-link",
    attrs: {
      "target": "_blank",
      "href": "https://clec.att.com/facilitiescheck/facilities_chk.cfm"
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v("  AT&T Lookup")]), _vm._v(" "), _c('router-link', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$canAccess(12, 32)),
      expression: "$canAccess(12, 32)"
    }],
    staticClass: "nav-link",
    attrs: {
      "to": "/quotes/location-info"
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v("  Location Info")]), _vm._v(" "), _c('router-link', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$canAccess(12, 33)),
      expression: "$canAccess(12, 33)"
    }],
    staticClass: "nav-link",
    attrs: {
      "to": "/quotes/telno-lookup"
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v("  Telno Lookup")])], 1)]), _vm._v(" "), _c('router-link', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasPermission(23)),
      expression: "hasPermission(23)"
    }],
    staticClass: "nav-link",
    attrs: {
      "to": "/map"
    }
  }, [_c('i', {
    staticClass: "fa fa-map"
  }), _vm._v("  Map")]), _vm._v(" "), _c('router-link', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasPermission(19)),
      expression: "hasPermission(19)"
    }],
    staticClass: "nav-link",
    attrs: {
      "to": "/agents"
    }
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v("  Agents")]), _vm._v(" "), _c('router-link', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasPermission(27)),
      expression: "hasPermission(27)"
    }],
    staticClass: "nav-link",
    attrs: {
      "to": "/leads"
    }
  }, [_c('i', {
    staticClass: "fa fa-user-circle-o"
  }), _vm._v("  Leads")]), _vm._v(" "), _c('router-link', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasPermission(8)),
      expression: "hasPermission(8)"
    }],
    staticClass: "nav-link",
    attrs: {
      "to": "/account-details"
    }
  }, [_c('i', {
    staticClass: "fa fa-user-circle-o"
  }), _vm._v("  Accounts")]), _vm._v(" "), _c('router-link', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasPermission(20)),
      expression: "hasPermission(20)"
    }],
    staticClass: "nav-link",
    attrs: {
      "to": "/dashboard"
    }
  }, [_c('i', {
    staticClass: "fa fa-bar-chart"
  }), _vm._v("  Dashboard")]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasPermission(19) || _vm.hasPermission(10)),
      expression: "hasPermission(19) || hasPermission(10) "
    }],
    staticClass: "nav-item dropdown"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu",
    attrs: {
      "aria-labelledby": "navbarDropdownMenuLink"
    }
  }, [_c('router-link', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasPermission(10)),
      expression: "hasPermission(10)"
    }],
    staticClass: "nav-link",
    attrs: {
      "to": "/setup"
    }
  }, [_c('i', {
    staticClass: "fa fa-gear"
  }), _vm._v("  Setup")]), _vm._v(" "), _c('router-link', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasPermission(26)),
      expression: "hasPermission(26)"
    }],
    staticClass: "nav-link",
    attrs: {
      "to": "/cashflow"
    }
  }, [_c('i', {
    staticClass: "fa fa-user-circle-o"
  }), _vm._v("  Cashflow")]), _vm._v(" "), _c('router-link', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasPermission(21)),
      expression: "hasPermission(21)"
    }],
    staticClass: "nav-link",
    attrs: {
      "to": "/carriers"
    }
  }, [_c('i', {
    staticClass: "fa fa-bar-chart"
  }), _vm._v("  Carriers")]), _vm._v(" "), _c('router-link', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$canAccess(21, 23)),
      expression: "$canAccess(21, 23)"
    }],
    staticClass: "nav-link",
    attrs: {
      "to": "/products"
    }
  }, [_c('i', {
    staticClass: "fa fa-tag"
  }), _vm._v("  Products")]), _vm._v(" "), _c('router-link', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasPermission(23)),
      expression: "hasPermission(23)"
    }],
    staticClass: "nav-link",
    attrs: {
      "to": "/carrier-serviceable-load"
    }
  }, [_c('i', {
    staticClass: "fa fa-map-marker"
  }), _vm._v("  Serviceability Upload")]), _vm._v(" "), _c('router-link', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$canAccess(24, 29)),
      expression: "$canAccess(24, 29)"
    }],
    staticClass: "nav-link",
    attrs: {
      "to": "/commission-matches"
    }
  }, [_c('i', {
    staticClass: "fa fa-link"
  }), _vm._v("   Commissions")]), _vm._v(" "), _c('router-link', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasPermission(9)),
      expression: "hasPermission(9)"
    }],
    staticClass: "nav-link",
    attrs: {
      "to": "/sales-team"
    }
  }, [_c('i', {
    staticClass: "fa fa-users"
  }), _vm._v("  Sales Team")]), _vm._v(" "), _c('router-link', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasPermission(14)),
      expression: "hasPermission(14)"
    }],
    staticClass: "nav-link",
    attrs: {
      "to": "/audit"
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v("  Audit")]), _vm._v(" "), _c('router-link', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasPermission(18)),
      expression: "hasPermission(18)"
    }],
    staticClass: "nav-link",
    attrs: {
      "to": "/reports"
    }
  }, [_c('i', {
    staticClass: "fa fa-pie-chart"
  }), _vm._v("  Reports")]), _vm._v(" "), _c('router-link', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasPermission(11)),
      expression: "hasPermission(11)"
    }],
    staticClass: "nav-link",
    attrs: {
      "to": "/utilities"
    }
  }, [_c('i', {
    staticClass: "fa fa-wrench"
  }), _vm._v("  Utilities")])], 1)]), _vm._v(" "), _c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/logout"
    }
  }, [_c('i', {
    staticClass: "fa fa-lock"
  }), _vm._v("  Logout")])], 1), _vm._v(" "), _c('div', {
    staticClass: "navbar-nav"
  }, [_c('span', {
    staticClass: "navbar-label"
  }, [_vm._v(" Logged In As:")]), _vm._v(" "), _c('auto-complete', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasPermission(22)),
      expression: "hasPermission(22)"
    }],
    attrs: {
      "placeholder": "Masquerade",
      "list": _vm.agentNames,
      "selection": _vm.selectedAgent,
      "loose": ""
    },
    on: {
      "change": _vm.changeAgent,
      "input": _vm.fetchAgents
    }
  })], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "navbar-toggler navbar-toggler-right",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#navbarNav",
      "aria-controls": "navbarNav",
      "aria-expanded": "false",
      "aria-label": "Toggle navigation"
    }
  }, [_c('span', {
    staticClass: "navbar-toggler-icon"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "navbar-brand",
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    attrs: {
      "id": "logo_img",
      "src": "/static/images/logo.png",
      "width": "200"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "nav-link dropdown-toggle",
    attrs: {
      "href": "http://example.com",
      "id": "navbarDropdownMenuLink",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-text"
  }), _vm._v("  Quoting\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "nav-link dropdown-toggle",
    attrs: {
      "href": "http://example.com",
      "id": "navbarDropdownMenuLink",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_c('i', {
    staticClass: "fa fa-gear"
  }), _vm._v("  Setup\n        ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-571c610c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/includes/Navigation.vue
// module id = 391
// module chunks = 0